export const ReleaseInfo = Object.freeze({
  releaseVersion: '2026.2.3-1412.01',
  commitId: 'c5b204f171fd4b6a70834a89503a3df1c346df2c',
  commitTime: '2026-02-03T14:12:01.000Z',
});
